import React from 'react'

export default function Notice({ children, ...props }) {
  return (
    <div className={'lc-notice'} {...props}>{children}</div>
  )
}
